const moneyPrefix = {
  IN: "₹",
};

export const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export function addSpaceToNumber(value, digit) {
  const spaceRegEx = new RegExp("(.{" + digit + "})", "g");
  value = value
    .replace(/[^\dA-Z]/g, "")
    .replace(spaceRegEx, "$1 ")
    .trim();
  return value;
}

export function setCookie(cname, cvalue, exdays, domain = '') {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  let cookieString = cname + "=" + cvalue + ";" + expires + ";path=/; Secure;";
  if (domain) {
    cookieString += ` domain=${domain}`;
  }
  document.cookie = cookieString;
}

export const formatAmountinINR = (val, insertSymbol = true) => {
  console.log("The value inside formatAmountinINR ", val);
  if (val === undefined || val === null || val === "") return "";
  let isAmountNegative = false;
  val = val.toString();

  if (val.includes("₹")) {
    val = val.replace("₹", "");
  }

  if (val.includes(",")) {
    val = val.replace(/,/g, "");
  }
  if (val.includes("-")) {
    val = val.replace(/-/g, "");
    isAmountNegative = true;
  }

  var afterPoint = "";
  if (val.indexOf(".") > 0)
    afterPoint = val.substring(val.indexOf("."), val.length);
  val = Math.floor(val);
  val = val.toString();
  var lastThree = val.substring(val.length - 3);
  var otherNumbers = val.substring(0, val.length - 3);
  if (otherNumbers != "") lastThree = "," + lastThree;
  var res =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;

  return insertSymbol
    ? `${isAmountNegative ? "-" : ""}${moneyPrefix["IN"]}${res}`
    : `${isAmountNegative ? "-" : ""}${res}`;
};

export const getDateFormat = (dt) => {
  const date = new Date(dt);
  const mArray = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const d = date.getDate();
  const m = mArray[date.getMonth()];
  const y = date.getFullYear();
  return "" + (d <= 9 ? "0" + d : d) + "-" + m + "-" + y;
};

export const getPaymentAmout = (amount) => {
  return amount.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "INR",
  });
};

export const postCall = (url, reqBody) => {
  const access_token = getCookie("oem_auth_token");
  if (typeof window == "undefined") return;
  if (!url) {
    return null;
  }
  let common = {
    oem_auth_token: getCookie("oem_auth_token"),
    utm_uuid: getCookie("utm_uuid"),
    buyer_utm_uuid: getCookie("buyer_utm_uuid"),
    exp_order_source_id: getCookie("exp_order_source_id"),
    buyer_name: getCookie("buyer_name"),
  };
  let data = { ...common, ...reqBody };
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  document.body.appendChild(form);
  for (const key in data) {
    if (data[key]) {
      const formField = document.createElement("input");
      formField.type = "hidden";
      formField.name = key;
      formField.value = data[key];
      form.appendChild(formField);
    }
  }
  form.submit();
  return null;
};

export const formatDate = (date) => {
  if (!date) {
    return "";
  }
  const formatted = new Date(date);
  let tmp = formatted.getDate();
  return [
    tmp + ([, "st", "nd", "rd"][/1?.$/.exec(tmp)] || "th"),
    [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ][formatted.getMonth()],
    formatted.getFullYear(),
  ].join(" ");
};

export const deleteCookie = (cookieNames) => {
  cookieNames.map((cookieName) => {
    if (cookieName === "eventkey") {
      document.cookie =
        "eventkey=; path=/; domain=.olacabs.com; expires=Sun, 20 Aug 2000 12:00:00 UTC";
    } else {
      document.cookie = `${cookieName}=; expires= Sun, 20 Aug 2000 12:00:00 UTC`;
    }
  });
};

/**
 * Maps legacy order status to the new status to display in UI.
 * Old statuses are not shown; only the corresponding new status is displayed.
 */
export const ORDER_STATUS_TO_NEW_MAPPING = {
  PURCHASED: "PURCHASED",
  ORDERED: "ORDER STARTED",
  DOCUMENTS_UPLOADED: "ORDER STARTED",
  DOCUMENTS_VERIFIED: "ORDERED",
  DISPATCHED: "ORDERED",
  INVOICE_GENERATED: "ORDERED",
  REGISTRATION_STARTED: "ORDERED",
  REGISTERED: "REGISTERED",
  CANCEL_REQUESTED: "CANCEL_REQUESTED",
  CANCELLED: "CANCELLED",
  REFUND_INITIATED: "REFUND_INITIATED",
  REFUNDED: "REFUNDED",
  READY_FOR_DELIVERY: "REGISTERED",
  REACHED_SDC: "ORDERED",
  OUT_FOR_DELIVERY: "REGISTERED",
  DELIVERED: "DELIVERED",
  INSURANCE_GENERATED: "ORDERED",
  INVENTORY_MAPPED: "ORDERED",
  CAF_GENERATED: "REGISTERED",
  PRC_GENERATED: "REGISTERED",
};

export const getDisplayStatus = (orderStatus) => {
  if (!orderStatus) return "";
  return ORDER_STATUS_TO_NEW_MAPPING[orderStatus] ?? orderStatus;
};
